import axios from './axiosInstance';

export const teamsList = async (params = {}) => {
  const response = await axios.get("/club_api/teams", { params });
  return response.data;
};

export const teamDetails = async (id) => {
  const response = await axios.get("/club_api/teams/" + id);
  return response.data;
};

export const createTeam = async (team) => {
  const response = await axios.post(`/club_api/teams/`, { team });
  return response.data; 
};

export const updateTeam = async (team) => {
  const response = await axios.put(`/club_api/teams/${team.id}`, { team });
  return response.data; 
};

export const deleteTeam = async (id) => {
  const response = await axios.delete(`/club_api/teams/${id}`);
  return response.data; 
};

export const assignTeamGroup = async (team_id, team_group_id, position) => {
  const response = await axios.put(`/club_api/teams/${team_id}`, { team_group_id, position });
  return response.data; 
};

export const fetchPractices = async (teamId, params, signal) => {
  const response = await axios.get(`/club_api/teams/${teamId}/practices`, { params, signal});
  return response.data;
};

export const getTeamGroups = async (params = {}) => {
  const response = await axios.get("/club_api/team_groups", { params });
  return response.data;
};

export const createTeamGroup = async (groupData) => {
  const response = await axios.post("/club_api/team_groups",{ group: groupData });
  return response.data;
};

export const updateTeamGroup = async (id, groupData) => {
  const response = await axios.put(`/club_api/team_groups/${id}`, { group: groupData });
  return response.data;
};

export const deleteTeamGroup = async (id) => {
  const response = await axios.delete(`/club_api/team_groups/${id}`);
  return response.data;
};

